import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, withKeys as _withKeys } from "vue"

const _hoisted_1 = { class: "card" }
const _hoisted_2 = { class: "row" }
const _hoisted_3 = /*#__PURE__*/_createVNode("div", { class: "col-md-3" }, [
  /*#__PURE__*/_createVNode("h1", { class: "title" }, [
    /*#__PURE__*/_createVNode("i", { class: "fa fa-bookmark mr-1 text-warning" }),
    /*#__PURE__*/_createTextVNode(" Invitation Details ")
  ])
], -1)
const _hoisted_4 = { class: "col-md-9" }
const _hoisted_5 = { class: "text-lg-right" }
const _hoisted_6 = /*#__PURE__*/_createVNode("i", { class: "fa fa-chevron-left mr-2" }, null, -1)
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" Edit")
const _hoisted_8 = /*#__PURE__*/_createVNode("i", { class: "fa fa-chevron-left mr-2" }, null, -1)
const _hoisted_9 = /*#__PURE__*/_createTextVNode(" Delete")
const _hoisted_10 = /*#__PURE__*/_createVNode("i", { class: "fa fa-chevron-left mr-2" }, null, -1)
const _hoisted_11 = /*#__PURE__*/_createTextVNode(" Go Back")
const _hoisted_12 = {
  key: 0,
  class: "table-loader chat-load"
}
const _hoisted_13 = {
  key: 1,
  class: "card mt-4"
}
const _hoisted_14 = { class: "form-wrap" }
const _hoisted_15 = { class: "row" }
const _hoisted_16 = { class: "col-md-6" }
const _hoisted_17 = { class: "form-group" }
const _hoisted_18 = /*#__PURE__*/_createVNode("label", { for: "" }, "Invite Existing Member", -1)
const _hoisted_19 = { key: 0 }
const _hoisted_20 = { class: "row align-items-center" }
const _hoisted_21 = { class: "col-md-9" }
const _hoisted_22 = { class: "inline-items" }
const _hoisted_23 = { class: "mr-3" }
const _hoisted_24 = {
  for: "",
  title: "Phase Name"
}
const _hoisted_25 = {
  class: "form-check-label",
  for: "inlineCheckbox10"
}
const _hoisted_26 = { class: "col-md-3 text-right" }
const _hoisted_27 = { class: "mb-3" }
const _hoisted_28 = /*#__PURE__*/_createVNode("strong", null, [
  /*#__PURE__*/_createVNode("small", null, "Status :")
], -1)
const _hoisted_29 = {
  key: 0,
  class: "badge badge-dim badge-success ml-1"
}
const _hoisted_30 = {
  key: 1,
  class: "badge badge-dim badge-light text-dark ml-1"
}
const _hoisted_31 = {
  key: 2,
  class: "badge badge-dim badge-danger ml-1"
}
const _hoisted_32 = {
  key: 3,
  class: "badge badge-dim badge-warning ml-1"
}
const _hoisted_33 = { class: "accordion-wrap" }
const _hoisted_34 = {
  class: "accordion",
  id: "accordionExample"
}
const _hoisted_35 = { class: "mb-0" }
const _hoisted_36 = /*#__PURE__*/_createVNode("input", {
  class: "form-check-input",
  type: "checkbox",
  checked: "",
  disabled: ""
}, null, -1)
const _hoisted_37 = {
  key: 0,
  class: "badge badge-dim badge-success ml-1"
}
const _hoisted_38 = {
  key: 1,
  class: "badge badge-dim badge-light text-dark ml-1"
}
const _hoisted_39 = {
  key: 2,
  class: "badge badge-dim badge-danger ml-1"
}
const _hoisted_40 = {
  key: 3,
  class: "badge badge-dim badge-warning ml-1"
}
const _hoisted_41 = { key: 0 }
const _hoisted_42 = { class: "card-body border mt-3 rounded p-3 share-block" }
const _hoisted_43 = /*#__PURE__*/_createVNode("div", { class: "absolute-text" }, [
  /*#__PURE__*/_createVNode("small", null, "Things To Share")
], -1)
const _hoisted_44 = { class: "inline-items" }
const _hoisted_45 = {
  class: "form-check-label",
  for: "inlineCheckbox11"
}
const _hoisted_46 = /*#__PURE__*/_createVNode("div", null, null, -1)
const _hoisted_47 = { class: "modal-wrap remove-user-modal default-modal" }
const _hoisted_48 = {
  class: "modal fade",
  id: "removeProjectShareInvitation",
  tabindex: -1,
  role: "dialog",
  "aria-labelledby": "exampleModalLabel",
  "aria-hidden": "true",
  "data-backdrop": "static",
  "data-keyboard": "false"
}
const _hoisted_49 = {
  class: "modal-dialog modal-dialog-centered",
  role: "document"
}
const _hoisted_50 = {
  key: 0,
  class: "modal-content h-auto"
}
const _hoisted_51 = { class: "modal-header" }
const _hoisted_52 = {
  key: 0,
  class: "modal-title",
  id: "exampleModalLabel"
}
const _hoisted_53 = /*#__PURE__*/_createVNode("span", { "aria-hidden": "true" }, "×", -1)
const _hoisted_54 = { class: "modal-body" }
const _hoisted_55 = /*#__PURE__*/_createVNode("p", null, [
  /*#__PURE__*/_createVNode("strong", null, " Removing user will:")
], -1)
const _hoisted_56 = { class: "block-list" }
const _hoisted_57 = { class: "modal-footer" }
const _hoisted_58 = { class: "modal-wrap default-modal" }
const _hoisted_59 = {
  class: "modal fade",
  "data-backdrop": "static",
  "data-keyboard": "false",
  id: "SuccessfulModalCustom",
  tabindex: "-1",
  "aria-labelledby": "inviteMember",
  "aria-hidden": "true"
}
const _hoisted_60 = { class: "modal-dialog modal-dialog-centered" }
const _hoisted_61 = { class: "modal-content text-center" }
const _hoisted_62 = { class: "msg-header" }
const _hoisted_63 = /*#__PURE__*/_createVNode("span", { "aria-hidden": "true" }, "×", -1)
const _hoisted_64 = /*#__PURE__*/_createVNode("div", { class: "icon" }, [
  /*#__PURE__*/_createVNode("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 16 16",
    class: "bi bi-check-circle",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    /*#__PURE__*/_createVNode("path", {
      "fill-rule": "evenodd",
      d: "M8 15A7 7 0 1 0 8 1a7 7 0 0 0 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"
    }),
    /*#__PURE__*/_createVNode("path", {
      "fill-rule": "evenodd",
      d: "M10.97 4.97a.75.75 0 0 1 1.071 1.05l-3.992 4.99a.75.75 0 0 1-1.08.02L4.324 8.384a.75.75 0 1 1 1.06-1.06l2.094 2.093 3.473-4.425a.236.236 0 0 1 .02-.022z"
    })
  ])
], -1)
const _hoisted_65 = { class: "msg-body" }
const _hoisted_66 = /*#__PURE__*/_createVNode("h3", null, "Successful!", -1)
const _hoisted_67 = {
  class: "alert alert-success text-center",
  role: "alert"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ToDoListBreadCrumb = _resolveComponent("ToDoListBreadCrumb")
  const _component_ErrorList = _resolveComponent("ErrorList")

  return (_openBlock(), _createBlock("div", null, [
    (!_ctx.state.ui.isLoading.projectShareInvitionDetails)
      ? (_openBlock(), _createBlock(_component_ToDoListBreadCrumb, {
          key: 0,
          project: _ctx.state.data.projectShareInvitionDetails.project,
          breadCrumbEndPoint: _ctx.state.data.endPoint
        }, null, 8, ["project", "breadCrumbEndPoint"]))
      : _createCommentVNode("", true),
    _createVNode("div", null, [
      _createVNode("div", _hoisted_1, [
        _createVNode("div", _hoisted_2, [
          _hoisted_3,
          _createVNode("div", _hoisted_4, [
            _createVNode("div", _hoisted_5, [
              _createVNode("a", {
                href: "javascript:void(0)",
                class: "btn default-btn outline d-inline-block mr-2 mb-1",
                onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.redirectToEdit && _ctx.redirectToEdit(...args)))
              }, [
                _hoisted_6,
                _hoisted_7
              ]),
              _createVNode("a", {
                href: "javascript:void(0)",
                class: "btn default-btn outline d-inline-block mr-2 mb-1",
                onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.selectShareProjectRemove(_ctx.state.data.projectShareInvitionDetails)))
              }, [
                _hoisted_8,
                _hoisted_9
              ]),
              _createVNode("a", {
                href: "javascript:void(0)",
                class: "btn default-btn outline d-inline-block mr-2 mb-1",
                onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.redirectToInvitation && _ctx.redirectToInvitation(...args)))
              }, [
                _hoisted_10,
                _hoisted_11
              ])
            ])
          ])
        ])
      ]),
      (_ctx.state.ui.isLoading.projectShareInvitionDetails)
        ? (_openBlock(), _createBlock("div", _hoisted_12, [
            _createVNode("img", {
              src: 
          _ctx.state.data.imageBaseUrl
            ? `${_ctx.state.data.imageBaseUrl}img/loader-spinner.gif`
            : 'img/loader-spinner.gif'
        ,
              alt: ""
            }, null, 8, ["src"])
          ]))
        : _createCommentVNode("", true),
      (!_ctx.state.ui.isLoading.projectShareInvitionDetails)
        ? (_openBlock(), _createBlock("div", _hoisted_13, [
            _createVNode("div", _hoisted_14, [
              _createVNode("div", _hoisted_15, [
                _createVNode("div", _hoisted_16, [
                  _createVNode("div", _hoisted_17, [
                    _hoisted_18,
                    (
                  _ctx.state.data.projectShareInvitionDetails &&
                  _ctx.state.data.projectShareInvitionDetails.email
                )
                      ? (_openBlock(), _createBlock("p", _hoisted_19, _toDisplayString(_ctx.state.data.projectShareInvitionDetails.email), 1))
                      : _createCommentVNode("", true)
                  ])
                ])
              ]),
              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.state.data
          .projectShareInvitionDetails.child_invitations, (childPhase, childPhaseIndex) => {
                return (_openBlock(), _createBlock("div", {
                  class: "alert alert-primary rounded mb-2 p-2",
                  key: childPhaseIndex
                }, [
                  _createVNode("div", _hoisted_20, [
                    _createVNode("div", _hoisted_21, [
                      _createVNode("div", _hoisted_22, [
                        _createVNode("ul", null, [
                          _createVNode("li", _hoisted_23, [
                            _createVNode("label", _hoisted_24, _toDisplayString(childPhase.name), 1)
                          ]),
                          _createVNode("li", null, [
                            (_openBlock(true), _createBlock(_Fragment, null, _renderList(childPhase.attributes, (phaseAtt, phaseAttIndex) => {
                              return (_openBlock(), _createBlock("div", {
                                class: "form-check form-check-inline",
                                key: phaseAttIndex
                              }, [
                                _createVNode("input", {
                                  class: "form-check-input",
                                  type: "checkbox",
                                  checked: phaseAtt.status == 1,
                                  id: "inlineCheckbox10",
                                  value: "option1",
                                  disabled: ""
                                }, null, 8, ["checked"]),
                                _createVNode("label", _hoisted_25, [
                                  _createVNode("small", null, _toDisplayString(phaseAtt.name), 1)
                                ])
                              ]))
                            }), 128))
                          ])
                        ])
                      ])
                    ]),
                    _createVNode("div", _hoisted_26, [
                      _createVNode("p", _hoisted_27, [
                        _hoisted_28,
                        (childPhase.is_complete === 1)
                          ? (_openBlock(), _createBlock("span", _hoisted_29, "Completed"))
                          : _createCommentVNode("", true),
                        (childPhase.partial === 1)
                          ? (_openBlock(), _createBlock("span", _hoisted_30, "Partially Accepted"))
                          : _createCommentVNode("", true),
                        (childPhase.is_declined === 1)
                          ? (_openBlock(), _createBlock("span", _hoisted_31, "Declined"))
                          : _createCommentVNode("", true),
                        (childPhase.is_complete === 0 && childPhase.is_declined === 0 && childPhase.partial === 0)
                          ? (_openBlock(), _createBlock("span", _hoisted_32, "Pending"))
                          : _createCommentVNode("", true)
                      ])
                    ])
                  ]),
                  _createVNode("div", _hoisted_33, [
                    _createVNode("div", _hoisted_34, [
                      (_openBlock(true), _createBlock(_Fragment, null, _renderList(childPhase.tasks, (task, taskIndex) => {
                        return (_openBlock(), _createBlock("div", {
                          class: "card rounded mb-2",
                          key: taskIndex
                        }, [
                          _createVNode("div", {
                            class: "card-header bg-white p-0 border-0",
                            id: `heading${task.uuid}`
                          }, [
                            _createVNode("h2", _hoisted_35, [
                              _createVNode("button", {
                                class: "btn btn-link btn-block text-left collapsed p-0",
                                type: "button",
                                "data-toggle": "collapse",
                                "data-target": `#collapse${task.uuid}`,
                                "aria-expanded": "false",
                                "aria-controls": `collapse${task.uuid}`
                              }, [
                                _hoisted_36,
                                _createTextVNode(" " + _toDisplayString(task.phase.name) + " ", 1),
                                (task.is_complete === 1)
                                  ? (_openBlock(), _createBlock("span", _hoisted_37, "Completed"))
                                  : _createCommentVNode("", true),
                                (task.partial === 1)
                                  ? (_openBlock(), _createBlock("span", _hoisted_38, "Partially Accepted"))
                                  : _createCommentVNode("", true),
                                (task.is_declined === 1)
                                  ? (_openBlock(), _createBlock("span", _hoisted_39, "Declined"))
                                  : _createCommentVNode("", true),
                                (task.is_complete === 0 && task.is_declined === 0)
                                  ? (_openBlock(), _createBlock("span", _hoisted_40, "Pending"))
                                  : _createCommentVNode("", true)
                              ], 8, ["data-target", "aria-controls"])
                            ]),
                            (task.status && task.status.detail )
                              ? (_openBlock(), _createBlock("span", _hoisted_41, _toDisplayString(task.status.detail), 1))
                              : _createCommentVNode("", true)
                          ], 8, ["id"]),
                          _createVNode("div", {
                            id: `collapse${task.uuid}`,
                            class: "collapse",
                            "aria-labelledby": `heading${task.uuid}`,
                            "data-parent": "#accordionExample"
                          }, [
                            _createVNode("div", _hoisted_42, [
                              _hoisted_43,
                              _createVNode("div", _hoisted_44, [
                                _createVNode("ul", null, [
                                  _createVNode("li", null, [
                                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(task.attributes, (attTask, attTaskIndex) => {
                                      return (_openBlock(), _createBlock("div", {
                                        class: "form-check form-check-inline",
                                        key: attTaskIndex
                                      }, [
                                        _createVNode("input", {
                                          class: "form-check-input",
                                          type: "checkbox",
                                          checked: attTask.status == 1,
                                          disabled: ""
                                        }, null, 8, ["checked"]),
                                        _createVNode("label", _hoisted_45, [
                                          _createVNode("small", null, _toDisplayString(attTask.name), 1)
                                        ])
                                      ]))
                                    }), 128))
                                  ])
                                ])
                              ])
                            ])
                          ], 8, ["id", "aria-labelledby"])
                        ]))
                      }), 128))
                    ])
                  ])
                ]))
              }), 128))
            ])
          ]))
        : _createCommentVNode("", true),
      _hoisted_46
    ]),
    _createVNode("div", _hoisted_47, [
      _createVNode("div", _hoisted_48, [
        _createVNode("div", _hoisted_49, [
          (_ctx.state.selectedShareInvitationForRemoval)
            ? (_openBlock(), _createBlock("div", _hoisted_50, [
                _createVNode("div", _hoisted_51, [
                  (
                _ctx.state.selectedShareInvitationForRemoval &&
                _ctx.state.selectedShareInvitationForRemoval.email
              )
                    ? (_openBlock(), _createBlock("h5", _hoisted_52, " Remove " + _toDisplayString(_ctx.state.selectedShareInvitationForRemoval.email) + " ? ", 1))
                    : _createCommentVNode("", true),
                  _createVNode("button", {
                    type: "button",
                    class: "close",
                    "aria-label": "Close",
                    onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.hideShareProjectRemove && _ctx.hideShareProjectRemove(...args)))
                  }, [
                    _hoisted_53
                  ])
                ]),
                _createVNode("div", _hoisted_54, [
                  _createVNode(_component_ErrorList, {
                    errors: _ctx.state.ui.errors.errorList.removeProjectRole,
                    hasError: _ctx.state.ui.errors.hasError
                  }, null, 8, ["errors", "hasError"]),
                  _hoisted_55,
                  _createVNode("div", _hoisted_56, [
                    _createVNode("ul", null, [
                      _createVNode("li", null, _toDisplayString(_ctx.state.selectedShareInvitationForRemoval.email) + " will be removed them from this share. ", 1)
                    ])
                  ])
                ]),
                _createVNode("div", _hoisted_57, [
                  _createVNode("button", {
                    type: "button",
                    class: "btn secondary-btn",
                    onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.hideShareProjectRemove && _ctx.hideShareProjectRemove(...args)))
                  }, " Cancel "),
                  _createVNode("button", {
                    type: "button",
                    class: "btn default-btn",
                    onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.removeShareInvitation && _ctx.removeShareInvitation(...args)))
                  }, _toDisplayString(_ctx.state.ui.isPostLoading.removeShareInvitation
                    ? "Removing..."
                    : "Yes,remove user."), 1)
                ])
              ]))
            : _createCommentVNode("", true)
        ])
      ])
    ]),
    _createVNode("div", _hoisted_58, [
      _createVNode("div", _hoisted_59, [
        _createVNode("div", _hoisted_60, [
          _createVNode("div", _hoisted_61, [
            _createVNode("div", _hoisted_62, [
              _createVNode("button", {
                type: "button",
                class: "close",
                onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.closeSuccessCustomModal && _ctx.closeSuccessCustomModal(...args))),
                onKeydown: _cache[8] || (_cache[8] = _withKeys(
//@ts-ignore
(...args) => (_ctx.closeSuccessCustomModal && _ctx.closeSuccessCustomModal(...args)), ["esc"])),
                "aria-label": "Close"
              }, [
                _hoisted_63
              ], 32),
              _hoisted_64
            ]),
            _createVNode("div", _hoisted_65, [
              _hoisted_66,
              _createVNode("div", _hoisted_67, _toDisplayString(_ctx.state.data.successFulMessage), 1)
            ])
          ])
        ])
      ])
    ])
  ]))
}